import { Avatar } from 'antd'
import React, { useMemo } from 'react'
import { getColorByLetter } from '../common/helpers';
import dayjs from 'dayjs';
import { DATE_FORMAT_DD_MM_YYYY_HH_mm_A } from '../constants/constants';
import DotIcon from './icons/DotIcon';

interface Props {
    data: any;
    onClick: () => void;
}
const MessageListItem = (props: Props) => {
    const { data } = props;

    const name = useMemo(() => {
        return data?.message?.senderUser?.organization?.company_name || data?.message?.senderUser?.partnerv2?.name || "Admin"
    }, [data])

    const avtartLetterColor = useMemo(() => getColorByLetter(name?.charAt(0)), [name]);

    return (
        <div className='p-[10px] hover:bg-[#ECFDF3] rounded-[8px] cursor-pointer' onClick={props.onClick}>
            <div className='flex items-center justify-between gap-x-[12px]'>
                <div className='flex items-center gap-x-[12px]'>
                    <Avatar style={avtartLetterColor}>{name?.charAt(0)}</Avatar>
                    <p className='text-[12px] font-[500] m-0 flex-1'>{data?.notification}</p>
                </div>
                {!data?.seen ? <DotIcon /> : <></>}
            </div>
            <p className='m-0 text-[#667085] text-[10px] text-end'>{dayjs(data.timestamp).format(DATE_FORMAT_DD_MM_YYYY_HH_mm_A)}</p>
        </div>

    )
}

export default MessageListItem